export default __webpack_public_path__ + "static/media/1-ActonaGroup.dea6f41e.png";